import { render, staticRenderFns } from "./RegionCascade.vue?vue&type=template&id=63f63591&scoped=true&"
import script from "./RegionCascade.vue?vue&type=script&lang=js&"
export * from "./RegionCascade.vue?vue&type=script&lang=js&"
import style0 from "./RegionCascade.vue?vue&type=style&index=0&id=63f63591&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f63591",
  null
  
)

export default component.exports